<template>
  <div data-v-db2fc762="" data-v-2ac6a5fc="" class="accountCenter">
    <!-- 基础信息设置 -->
    <div data-v-db2fc762="" class="row">
      <h4 data-v-db2fc762="">基础信息设置</h4>
      <div data-v-db2fc762="" class="list">
        <!-- 真实姓名（无跳转） -->
        <div data-v-db2fc762="" class="item">
          <p data-v-db2fc762="" class="item-label">真实姓名</p>
          <p data-v-db2fc762="" class="item-value">{{ $store.state.userInfo.realname || '未设置' }}</p>
        </div>
        <!-- 登录密码（可修改） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/resetPasswordNew')">
          <p data-v-db2fc762="" class="item-label">登录密码</p>
          <div data-v-db2fc762="" class="item-right">
            <a data-v-db2fc762="" class="item-btn">修改</a>
            <i data-v-db2fc762="" class="arrow"></i>
          </div>
        </div>
        <!-- 手机号码（绑定/修改） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/modifyPhone')">
          <p data-v-db2fc762="" class="item-label">手机号码</p>
          <div data-v-db2fc762="" class="item-right">
            <p data-v-db2fc762="" class="item-value">{{ $store.state.userInfo.mobile || '未绑定' }}</p>
            <a data-v-db2fc762="" class="item-btn">{{ $store.state.userInfo.mobile ? '修改' : '去绑定' }}</a>
            <i data-v-db2fc762="" class="arrow"></i>
          </div>
        </div>
        <!-- 电子邮箱（绑定/修改） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/modifyEmail')">
          <p data-v-db2fc762="" class="item-label">电子邮箱</p>
          <div data-v-db2fc762="" class="item-right">
            <p data-v-db2fc762="" class="item-value">{{ $store.state.userInfo.email || '未绑定' }}</p>
            <a data-v-db2fc762="" class="item-btn">{{ $store.state.userInfo.email ? '修改' : '去绑定' }}</a>
            <i data-v-db2fc762="" class="arrow"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 取款交易设置 -->
    <div data-v-db2fc762="" class="row">
      <h4 data-v-db2fc762="">
        取款交易设置
        <span data-v-db2fc762="" class="row-desc">进行取款操作需完成以下操作</span>
      </h4>
      <div data-v-db2fc762="" class="list">
        <!-- 银行卡管理（跳转） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/bankCard')">
          <p data-v-db2fc762="" class="item-label">银行卡管理</p>
          <i data-v-db2fc762="" class="arrow"></i>
        </div>
        <!-- 资金密码（修改） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/modifyPayPassword')">
          <p data-v-db2fc762="" class="item-label">资金密码</p>
          <div data-v-db2fc762="" class="item-right">
            <a data-v-db2fc762="" class="item-btn">修改</a>
            <i data-v-db2fc762="" class="arrow"></i>
          </div>
        </div>
      </div>
    </div>

    <!-- 代理及活动 -->
    <div data-v-db2fc762="" class="row">
      <h4 data-v-db2fc762="">活动详情</h4>
      <div data-v-db2fc762="" class="list">
        <!-- 活动列表（跳转） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/activeList')">
          <p data-v-db2fc762="" class="item-label">活动列表</p>
          <i data-v-db2fc762="" class="arrow"></i>
        </div>
        <!-- 活动申请记录（跳转） -->
        <div data-v-db2fc762="" class="item item-link" @click="$parent.goNav('/applyagentList')">
          <p data-v-db2fc762="" class="item-label">活动申请记录</p>
          <i data-v-db2fc762="" class="arrow"></i>
        </div>
      </div>
    </div>
  </div> <!-- 确保最外层div闭合 -->
</template>

<script>
export default {
  name: 'accountCenter',
  data() {
    return {};
  },
  mounted() {
    document.body.style.backgroundColor = '#f9fafb';
    document.documentElement.style.backgroundColor = '#f9fafb';
  }
};
</script>

<style lang="scss" scoped>
// 1. 基础变量（与前序页面统一）
$white: #ffffff;
$bg-light: #f9fafb;
$card-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
$border-gray: #e5e7eb;
$text-main: #1f2937;
$text-secondary: #6b7280;
$text-link: #165dff;
$arrow-color: #d1d5db;
$transition: all 0.2s ease;
$radius: 8px;

// 2. 全局背景覆盖（解决外部样式污染）
::v-deep html,
::v-deep body,
::v-deep #app {
  background-color: $bg-light !important;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

// 3. 页面容器（修正高度，适配底部导航）
.accountCenter {
  width: 100%;
  // 假设：顶部导航60px + 底部导航50px = 总扣减110px，按需调整
  min-height: calc(100vh - 110px);
  background-color: $bg-light;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 0;
}

// 4. 模块卡片（白色UI核心）
.row {
  background-color: $white;
  border-radius: $radius;
  box-shadow: $card-shadow;
  padding: 18px;
  margin-bottom: 16px;

  h4 {
    font-size: 16px;
    color: $text-main;
    font-weight: 500;
    margin: 0 0 16px 0;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .row-desc {
    font-size: 12px;
    color: $text-secondary;
    font-weight: normal;
    margin-left: 8px;
  }
}

// 5. 列表容器
.list {
  width: 100%;
}

// 6. 列表项（配套样式）
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 2px;
  border-bottom: 1px solid $border-gray;

  &:last-child {
    border-bottom: none;
  }

  .item-label {
    font-size: 14px;
    color: $text-main;
    margin: 0;
    padding: 0;
  }

  .item-value {
    font-size: 14px;
    color: $text-secondary;
    margin: 0 8px 0 0;
    padding: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-right {
    display: flex;
    align-items: center;
  }

  .item-btn {
    font-size: 14px;
    color: $text-link;
    text-decoration: none;
    margin-right: 8px;
    cursor: pointer;
    transition: $transition;

    &:hover {
      color: #0e42d2;
    }
  }

  .arrow {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-top: 2px solid $arrow-color;
    border-right: 2px solid $arrow-color;
    transform: rotate(45deg);
    transition: $transition;
  }

  &.item-link {
    cursor: pointer;
    transition: $transition;

    &:hover {
      background-color: rgba(22, 93, 255, 0.03);
      
      .arrow {
        border-color: $text-link;
      }
    }
  }
}

// 8. 移动端适配
@media (max-width: 375px) {
  .accountCenter {
    padding: 12px;
    min-height: calc(100vh - 100px); // 小屏微调（底部导航45px）
  }

  .row {
    padding: 14px;
    margin-bottom: 12px;
  }

  .item {
    height: 48px;
  }

  .item-label,
  .item-value,
  .item-btn {
    font-size: 13px;
  }

  .footerWrap {
    height: 45px;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/main/accountCenter.vue